import { UseMutationResult, useMutation } from "react-query";

import { useAuth } from "../../sdk/hooks";
import { IEntityAttribute, api } from "../../utils";
import { EntityAttributeType } from "../../utils/enums";

export interface IUpdateEntityAttributeParameter {
    name: string;
    required: boolean;
    groupId: string;
    type: EntityAttributeType;
    exclusive?: boolean;
    min?: number;
    max?: number;
    pattern?: string;
    default?: JSON;
    attributeId: string;
}

export const useUpdateEntityAttribute = (
    queryKey: string | string[],
): UseMutationResult<
    IEntityAttribute,
    unknown,
    IUpdateEntityAttributeParameter
> => {
    const auth = useAuth();
    return useMutation({
        mutationFn: async (parameters: IUpdateEntityAttributeParameter) => {
            if (!auth.token) {
                throw new Error(
                    "Cannot update entity attribute without authorization token.",
                );
            }

            return await api.EntityAttribute.update({
                ...parameters,
                token: auth.token,
            });
        },
    });
};
